import {IconButton, Image, IconButtonProps} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';

type Props = Omit<IconButtonProps, 'type' | 'aria-label' | 'icon'>;

export default function DeleteButton(props: Props) {
  return <IconButton type="button" aria-label="削除" icon={<Image src={`${IMAGE_PREFIX}icon-graph-01.png`} alt="削除" />} {...props} />;
}
